const calcularColorSegunMeses = (fechaEntrega, durationMonths) => {
    console.log("fechaEntrega", fechaEntrega)
    
    // Convertir la fecha de entrega a un objeto Date
    const fechaEntregaDate = new Date(fechaEntrega);

    // Obtener la fecha actual
    const fechaActual = new Date();

    // Calcular la diferencia en meses
    let mesesTranscurridos = (fechaActual.getFullYear() - fechaEntregaDate.getFullYear()) * 12;
    mesesTranscurridos += fechaActual.getMonth() - fechaEntregaDate.getMonth();

    // Ajustar si el día actual es menor que el día de la fecha de entrega
    if (fechaActual.getDate() < fechaEntregaDate.getDate()) {
        mesesTranscurridos--;
    }
    console.log("mesesTranscurridos", mesesTranscurridos)
    console.log("durationMonths", durationMonths)
    // Determinar el color basado en los meses transcurridos
    if (mesesTranscurridos < durationMonths / 2) {
        return 'red';
    } else if (mesesTranscurridos < durationMonths) {
        return 'yellow';
    } else {
        return 'green';
    }
}

export default calcularColorSegunMeses;
